import React from 'react';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  const plans = [{
    name: 'Standard',
    subtitle: 'für kleine Kanzleien',
    price: '199',
    features: ['Bis 100 Fälle/Mon.', 'Alle Kernfunktionen', 'E-Mail Support', 'DSGVO-konform']
  }, {
    name: 'Professional',
    subtitle: 'für mittelgroße Kanzleien',
    price: '349',
    features: ['Bis 500 Fälle/Mon.', 'Alles aus Standard', 'Teamverwaltung', 'Erweiterte Workflows', 'Prioritäts-Support'],
    highlighted: true
  }, {
    name: 'Enterprise',
    subtitle: 'für größere Einheiten',
    price: '699',
    features: ['Unbegrenzte Fälle', 'Alles aus Professional', 'Volle Automatisierungsbibliothek', 'Individuelle Integration', 'Dedizierter Account Manager'],
    noPrefix: true
  }];
  return <section className="py-20 bg-gray-50" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-122">
          <h2 id="pricing" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-123">
            Transparente Preismodelle – ohne Risiko
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12" data-id="element-124">
          {plans.map((plan, index) => <div key={index} className={`rounded-xl p-8 ${plan.highlighted ? 'bg-blue-600 text-white shadow-2xl transform scale-105' : 'bg-white shadow-lg'}`} data-id="element-125">
              <h3 className={`text-2xl font-bold mb-2 ${plan.highlighted ? 'text-white' : 'text-gray-900'}`} data-id="element-126">
                {plan.name}
              </h3>
              <p className={`text-sm mb-4 ${plan.highlighted ? 'text-blue-100' : 'text-gray-600'}`} data-id="element-127">
                {plan.subtitle}
              </p>
              <div className="mb-6" data-id="element-128">
                {!plan.noPrefix && <span className="text-lg font-semibold mr-1" data-id="element-129">ab</span>}
                <span className={`text-5xl font-bold ${plan.highlighted ? 'text-white' : 'text-gray-900'}`} data-id="element-130">
                  {plan.price}€
                </span>
                <span className={`text-lg ${plan.highlighted ? 'text-blue-100' : 'text-gray-600'}`} data-id="element-131">
                  {' '}
                  / Monat
                </span>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-132">
                {plan.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-133">
                    <CheckIcon className={`w-5 h-5 flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-blue-200' : 'text-green-600'}`} data-id="element-134" />
                    <span className={plan.highlighted ? 'text-blue-50' : 'text-gray-700'} data-id="element-135">
                      {feature}
                    </span>
                  </li>)}
              </ul>
              <button className={`w-full py-3 rounded-lg font-semibold transition-colors ${plan.highlighted ? 'bg-white text-blue-600 hover:bg-gray-100' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-136">
                Jetzt starten
              </button>
            </div>)}
        </div>
      </div>
    </section>;
}